import { useCallback, useEffect, useRef, useState } from 'react';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const RenameInput = ({
  initialValue,
  onSave,
  onCancel,
  ariaLabel
}) => {
  const inputRef = useRef(null);
  const [value, setValue] = useState(initialValue);
  const isResolvedRef = useRef(false);
  const blurEnabledRef = useRef(false);
  useEffect(() => {
    var _inputRef$current, _inputRef$current2;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.select();
    const raf = requestAnimationFrame(() => {
      blurEnabledRef.current = true;
    });
    return () => cancelAnimationFrame(raf);
  }, []);
  const resolveSave = useCallback(raw => {
    if (isResolvedRef.current) return;
    isResolvedRef.current = true;
    const trimmed = raw.trim();
    if (trimmed === '' || trimmed === initialValue) {
      onCancel();
      return;
    }
    onSave(trimmed);
  }, [initialValue, onSave, onCancel]);
  const resolveCancel = useCallback(() => {
    if (isResolvedRef.current) return;
    isResolvedRef.current = true;
    onCancel();
  }, [onCancel]);
  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.stopPropagation();
      e.preventDefault();
      resolveSave(value);
      return;
    }
    if (e.key === 'Escape') {
      e.stopPropagation();
      e.preventDefault();
      resolveCancel();
    }
  };
  return /*#__PURE__*/_jsx(TextInput, {
    inputRef: inputRef,
    "aria-label": ariaLabel,
    value: value,
    onChange: e => setValue(e.target.value),
    onKeyDown: handleKeyDown,
    onBlur: () => {
      if (blurEnabledRef.current) resolveSave(value);
    },
    onClick: e => e.stopPropagation()
  });
};